import { MNSproCloudApi } from '..';
import { TenantSearchResponse } from '../api/v2';

export class SearchesService {
  static async search(
    authToken: string,
    searchTerm: string,
    organizationId: string,
  ): Promise<TenantSearchResponse[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.SearchesApiFactory(config);
    const response = await api.any(searchTerm, organizationId);

    return response.data;
  }
}
